export const SET_SOUND = "settings/SET_SOUND";
export const SET_LOCALE = "settings/SET_LOCALE";
export const SET_COLOR_MODE = "settings/SET_COLOR_MODE";
export const SET_NOTIFICATION = "settings/SET_NOTIFICATION";
